import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconRing = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <circle cx='12' cy='12' r='8' fill='none' stroke='currentColor' strokeWidth='2.4' />
  </SDIcon>
)

export default IconRing
